import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import NavbarIconsInnovation from "../generic-nav-bar/NavbarIconsInnovation";
import FlowEngineSection from "../specialist-flow-engine/FlowEngineSection";
import useFormValidations from "../../app/hooks/useFormValidations";
import { useHydrateViewCatalogRelations } from "../../app/hooks/useHydrateViewCatalogRelations";
import { getObjectByCode } from "../../app/helpers/getObjectByCode";
import { Link } from "react-router-dom";
import { debugLogPages } from "../../app/helpers/debugHelper";
import { getObjectById } from "../../app/helpers/getObjectById";
import { startLoadingCatalogCiiusAll } from "../../app/actions/catalogCiiuActions";
import { startLoadingCatalogSectionsAll } from "../../app/actions/catalogSectionActions";
import { startLoadingCatalogPhasesAll } from "../../app/actions/catalogPhaseActions";
import { startLoadingContinents } from "../../app/actions/continentActions";
import { startLoadingRegions } from "../../app/actions/regionActions";
import { startLoadingCountries } from "../../app/actions/countryActions";
import IntegrationViewChrome from "../end-user-search/IntegrationViewChrome";
import { useIntegrationNestedPreview } from "../end-user-search/integrationNestedPreviewContext";
import DetailSectionsLayout from "../end-user-search/DetailSectionsLayout";
import { getSectionHeader } from "../../app/helpers/helperValidationViewPreview";

const ViewInnovation = () => {
  debugLogPages(':: ViewInnovation');

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { nested, setDetailMode } = useIntegrationNestedPreview();

  /********Store*******/
  const { innovationSelected } = useSelector((state) => state.innovation);

  const { listFullCatalogCiius } =
    useSelector((state) => state.catalogCiiu);

  const { listFullCatalogSections } =
    useSelector((state) => state.catalogSection);

  const { listFullCatalogPhases } =
    useSelector((state) => state.catalogPhase);

  const { listContinents, listFullRegions } = useSelector((state) => state.locationCountry);

  const { listFieldsInnovationView, listFieldsInnovationPreview } = useSelector((state) => state.moduleConfig);

  /********UseForm*******/
  const { values, handleChangeCatalogCiiu, handleChangeCatalogSection, handleChangeCatalogPhase, setValues } = useFormValidations(
      () => InnovationCallback(),
      innovationSelected,
      listFieldsInnovationView
    );

  const InnovationCallback = () => {
    
  };

  useHydrateViewCatalogRelations('Innovation', values, setValues);

  useEffect(() => {
    if (!nested) return undefined;
    dispatch(startLoadingCatalogCiiusAll());
    dispatch(startLoadingCatalogSectionsAll());
    dispatch(startLoadingCatalogPhasesAll());
    dispatch(startLoadingContinents());
    dispatch(startLoadingRegions());
    dispatch(startLoadingCountries());
    return undefined;
  }, [nested, dispatch]);

  useEffect(() => {
    
    if (values && values.catalogciius_id && listFullCatalogCiius) {
      let codigosCiius = values.catalogciiu_levels;

      let partes = codigosCiius.split(";");

      var objectCiiuFound = [];

      var currentCatalogCiiuLevelInValues = {
        1: values.catalogciiu_level1,
        2: values.catalogciiu_level2,
        3: values.catalogciiu_level3,
        4: values.catalogciiu_level4,
        5: values.catalogciiu_level5,
        6: values.catalogciiu_level6,
      };

      for (let i = 0; i < partes.length; i++) {

        objectCiiuFound[i] = getObjectByCode(partes[i], listFullCatalogCiius);
        
        handleChangeCatalogCiiu(objectCiiuFound[i], i + 1);

        currentCatalogCiiuLevelInValues[i + 1] = objectCiiuFound[i].id;
      }
    }

  }, [listFullCatalogCiius]);

  useEffect(() => {
    
    if (values && values.catalogsections_id && listFullCatalogSections) {
      let codigosSections = values.catalogsection_levels;

      let partes = codigosSections.split(";");

      var objectSectionFound = [];

      var currentCatalogSectionLevelInValues = {
        1: values.catalogsection_level1,
        2: values.catalogsection_level2,
        3: values.catalogsection_level3,
        
      };

      for (let i = 0; i < partes.length; i++) {
        
        objectSectionFound[i] = getObjectByCode(partes[i], listFullCatalogSections);
        
        handleChangeCatalogSection(objectSectionFound[i], i + 1);

        currentCatalogSectionLevelInValues[i + 1] = objectSectionFound[i].id;
      }
    }

  }, [listFullCatalogSections]);

    useEffect(() => {
      
      if (values && values.catalogphases_id && listFullCatalogPhases) {
        let codigosPhases = values.catalogphase_levels;

        let partes = codigosPhases.split(";");

        var objectPhaseFound = [];
  
        var currentCatalogPhaseLevelInValues = {
          1: values.catalogphase_level1,
          2: values.catalogphase_level2,
          3: values.catalogphase_level3,
          4: values.catalogphase_level4
        };

        for (let i = 0; i < partes.length; i++) {
          objectPhaseFound[i] = getObjectByCode(partes[i], listFullCatalogPhases);
          
          handleChangeCatalogPhase(objectPhaseFound[i], i + 1);
  
          currentCatalogPhaseLevelInValues[i + 1] = objectPhaseFound[i].id;
        }
      }
  
    }, [listFullCatalogPhases]);

 useEffect(() => {
 
     if (values && values.catalogregions_id && listFullRegions) {
       
       const elementFoundLevel = getObjectById(values.catalogregions_id, listFullRegions);

       setValues((values) => ({ ...values, 'CatalogRegion_To_Innovation': elementFoundLevel }));
       
     }
 
     if (values && values.catalogcontinents_id && listContinents) {

       const elementFoundLevel = getObjectById(values.catalogcontinents_id, listContinents);

       setValues((values) => ({ ...values, 'CatalogContinent_To_Innovation': elementFoundLevel }));
       
     }
 
   }, [listFullRegions,listContinents, values.catalogcontinents_id, values.catalogregions_id]);

  const { arrayListPrincipal, arrayListSecondary } = listFieldsInnovationPreview;

  const innovationViewRelations = {
    multimedia: "ModuleFile_To_Innovation",
    problems: "ModuleProblem_To_Innovation"
  };

  const sharedViewProps = {
    values,
    t,
    ProblemTableComponent: null, // 💡 Pasamos null para que el motor ignore el renderizado de la tabla
    relationKeys: innovationViewRelations,
    isPreviewMode: false 
  };

      const principalHeader = getSectionHeader(arrayListPrincipal);
      const secondaryHeader = getSectionHeader(arrayListSecondary);

  const onGoSummaryVersion = (e) => {
    if (!nested || !setDetailMode) return;
    e.preventDefault();
    setDetailMode('preview');
  };

  return (
    <div>
      {!nested && <NavbarIconsInnovation page={"viewText"} />}

      {!nested && (
        <IntegrationViewChrome
          sourceModuleKey="innovation"
          record={innovationSelected}
        />
      )}

      <div className="d-flex justify-content-center page-title">{t("innovation.view.title")}</div>
      <hr className="line-hr" />
      <div className="section is-fullheight">
        <div className="container">
          <form>
            <div className="container-fluid">
              <div className="text-center fw-bolder">
                <div className="text-center">
                  {nested ? (
                    <button
                      type="button"
                      className="btn btn-link p-0 fw-bolder"
                      onClick={onGoSummaryVersion}
                    >
                      {t("innovation.view.redirect")}
                    </button>
                  ) : (
                    <Link to="/end-user-search/preview-innovation">
                      {t("innovation.view.redirect")}
                    </Link>
                  )}
                </div>
              </div>
              <DetailSectionsLayout
                nested={nested}
                isPreviewMode={false}
                arrayListPrincipal={arrayListPrincipal}
                arrayListSecondary={arrayListSecondary}
                principalHeader={principalHeader}
                secondaryHeader={secondaryHeader}
                sharedViewProps={sharedViewProps}
              />
            </div>

            <FlowEngineSection
              record={innovationSelected}
              moduleProcess="innovation"
              moduleName={t("innovation.view.title")}
              onAfterAction={() => {}}
            />
          </form>
        </div>
      </div>
    </div>
  );
};

export default ViewInnovation;
